/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import instagram from "../assets/images/instagram.svg";
import twitter from "../assets/images/twitter.svg";
import poweredBySindion from "../assets/images/powered.svg";
import "./Footer.css";
import { Fade } from "react-reveal";

export default function Footer() {
  return (
    <div className="footer">
      <Fade bottom>
        <p>| Follow us on </p>
        <img src={instagram} alt="instagram" />
        <a href="https://www.instagram.com/valuexperts.om/">valuexperts.om</a>
        <img src={twitter} alt="twitter" />
        <a href="https://twitter.com/valueexperts_OM">valueexperts_om</a>
        <div
          onClick={() => {
            window.open("https://www.sindion.com/", "_blank");
          }}
          className="footer-powered"
        >
          <img src={poweredBySindion} alt="poweredBySindion" />
        </div>
      </Fade>
    </div>
  );
}
